const axios = require('axios').default
const API_URL =
    process.env.MEMBER_DATA_URL ||
    process.env.REACT_APP_MEMBER_DATA_URL ||
    'https://member-data-api.centivo.dev/'
const API_ACCESS_TOKEN =
    process.env.MEMBER_DATA_ACCESS_TOKEN ||
    process.env.REACT_APP_MEMBER_DATA_ACCESS_TOKEN
axios.defaults.timeout = 30000
if (API_ACCESS_TOKEN == null) {
    console.log('Missing access token for member service.')
}

const handle404Error = e => {
    try {
        if (e.response.status.toString() === '404') {
            return []
        }
    } catch (e2) {
        console.log('ORIGINAL ERROR THROWING CATCH ERROR:', e)
        throw e2
    }
}

exports.getMemberData = async memberUuid => {
    let response = null
    try {
        response = await axios.get(`${API_URL}getMemberData`, {
            headers: {
                'content-type': 'application/json',
                Authorization: API_ACCESS_TOKEN,
            },
            params: {
                memberUuid: memberUuid,
            },
        })
        if (response.status !== 200) {
            return null
        }
        return response.data
    } catch (e) {
        return handle404Error(e)
    }
}

exports.getMemberDataByCertificateNumber = async certificateNumber => {
    let response = null
    try {
        response = await axios.get(
            `${API_URL}getMemberDataByCertificateNumber`,
            {
                headers: {
                    'content-type': 'application/json',
                    Authorization: API_ACCESS_TOKEN,
                },
                params: {
                    certificateNumber: certificateNumber,
                },
            }
        )
        if (response.status !== 200) {
            return null
        }
        return response.data
    } catch (e) {
        return handle404Error(e)
    }
}

exports.getMembersByPcpTin = async (tin, lastEvalKey) => {
    let response = null
    try {
        response = await axios.get(`${API_URL}getMembersByPcpTin`, {
            headers: {
                'content-type': 'application/json',
                Authorization: API_ACCESS_TOKEN,
            },
            params: {
                tin: tin,
                lastEvalKey: lastEvalKey
            },
        })
        if (response.status !== 200) {
            return null
        }
        return response.data
    } catch (e) {
        return handle404Error(e)
    }
}

/**
 * @param {*} memberUuid
 * @returns
 */
 exports.getPcpTransactionsByMember = async (memberUuid) => {
    try {
        const response = await axios.get(
            `${API_URL}getPcpTransactionsByMember`,
            {
                headers: {
                    'content-type': 'application/json',
                    Authorization: API_ACCESS_TOKEN,
                },
                params: {
                    memberUuid,
                },
            }
        )
        if (response.status !== 200) {
            return null
        }
        return response.data
    } catch (e) {
        return handle404Error(e)
    }
}

/**
 * @param {*} tin
 * @param {*} options (currently supports enableCustomCompression as a header set to true for compression calls)
 * @returns
 */
exports.getMembersAndPcpTransactionByPcpTin = async (tin, options = {}) => {
    try {
        const response = await axios.get(
            `${API_URL}getMembersAndPcpTransactionByPcpTin`,
            {
                headers: {
                    'content-type': 'application/json',
                    Authorization: API_ACCESS_TOKEN,
                    ...options?.headers,
                },
                params: {
                    tin,
                    ...options?.params,
                },
            }
        )
        if (response.status !== 200) {
            return null
        }
        return response.data
    } catch (e) {
        return handle404Error(e)
    }
}

/**
 * @param {{
 *  queryParams: {
 *    memberUuid: string
 *    pcpChosenBy: string
 *  }
 *  body: {
 *    carepoint: Record<string, any>
 *    meta: Record<string, any>
 *  }
 *  headers: Record<string, string>
 * }} params
 */
exports.putPcpTransactionWithCarepoint = async ({
    queryParams,
    body,
    headers,
}) => {
    try {
        const response = await axios.put(
            `${API_URL}putPcpTransactionWithCarepoint`,
            body,
            {
                headers: {
                    'content-type': 'application/json',
                    Authorization: API_ACCESS_TOKEN,
                    ...headers,
                },
                params: queryParams,
            }
        )
        if (response.status !== 200) {
            return { code: response.status, error: response.data }
        }
        return { code: response.status, data: response.data }
    } catch (err) {
        return { code: 500, error: err }
    }
}
